<template>
    <div class="login">
        <div class="login-box">
            <div class="login-content">
                <div class="login-content-from">
                    <img class="login-from-top" src="@/assets/img/ht_box_top.gif" alt="">
                    <ul class="from-menu">
                        <li class="from-li-item">
                            <span class="from-li-span">用户账号:</span>
                            <input class="from-li-input" v-focus v-model="phonenumber" @keyup.enter="SubMitClick" type="text" />
                        </li>
                        <li class="from-li-item">
                            <span class="from-li-span">登录密码：</span>
                            <input class="from-li-input" v-model="password" @keyup.enter="SubMitClick" type="password" />
                        </li>
                        <li class="from-li-item">
                            <span class="from-li-span"></span>
                            <button class="from-li-button cp" @click="SubMitClick">登录</button>
                        </li>
                    </ul>
                </div>
                <img class="login-content-bgc" src="@/assets/img/bg.png" alt="">
            </div>
            <div class="login-title-link">
                <a href="https://beian.miit.gov.cn/" target="_blank">闽ICP备2024062159号-1</a>
            </div>
        </div>
    </div>
</template>

<script>
import { loginApi } from "@/api/loginApi.js";
export default {
    data() {
        return {
            phonenumber: "",
            password: ""
        }
    },
    methods: {
        //登录
        SubMitClick() {
            if (!this.phonenumber) {
                alert("请输入账号")
                return
            }

            if (!this.password) {
                alert("请输入密码")
                return
            }

            loginApi({
                phonenumber: this.phonenumber,
                password: this.password
            }).then(res => {
                if (res.code == 1) {
                    if (res.data.useronoff == 1) {
                        this.$setVal("Token", res.data.token)
                        this.$router.push("/home")
                    } else {
                        alert("你已经被禁用登录，请联系管理员解禁！")
                    }
                } else {
                    alert(res.msg)
                }
            })
        },
    },
}
</script>

<style scoped lang="scss">
.login {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .login-box {
        width: auto;
        height: auto;
        margin-top: 100px;
    }

    .login-title-link {
        width: 100%;
        margin-top: 150px;
        font-size: 12px;
        text-align: center;

        a {
            color: #006799;
            text-decoration: underline;
        }
    }

    .login-content {
        min-width: 755px;
        min-height: 265px;
        position: relative;

        .login-content-from {
            width: 267px;
            height: 265px;
            border-radius: 5px;
            background-color: #fff;
            border: 1px solid #999;
            position: absolute;
            right: 60px;
            top: 0;
            z-index: 2;

            .from-menu {
                width: 100%;
                padding: 30px 30px;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;

                .from-li-item {
                    width: 100%;
                    margin-bottom: 18px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .from-li-button {
                        width: 100%;
                        height: 30px;
                        margin-top: 35px;
                        font-size: 12px;
                    }

                    .from-li-input:focus {
                        border: 2px solid #111 !important;
                    }

                    .from-li-input {
                        width: 130px;
                        font-family: Tahoma;
                        background: white;
                        font-size: 12px;
                        border-radius: 3px;
                        border: 1px solid #84A1BD;
                        line-height: 23px;
                        padding: 0 3px;
                        height: 23px;
                        box-sizing: border-box;
                    }

                    .from-li-span {
                        flex: 1;
                        font-size: 13px;
                        color: #000;
                    }
                }
            }

            .login-from-top {
                width: 100%;
                height: auto;
            }
        }

        .login-content-bgc {
            width: 755px;
            height: 155px;
            position: absolute;
            left: 0;
            top: calc((100% - 155px)/2);
            z-index: 1;
        }
    }
}
</style>